import ApiRequest from '../api/ApiRequest';

const apiRequest = new ApiRequest('roles');

export default {
  state: {
    roles: [],
  },
  namespaced: true,
  mutations: {
    async saveRolesStore(state, roles) {
      state.roles = roles;
    },
    async createRole(state, role) {
      const roles = state.roles.concat(role.data);
      state.roles = roles;
    },
    async updateRole(state, role) {
      const index = state.roles.findIndex((el) => el.id === role.data.id);
      Object.assign(state.roles[index], role.data);
    },
  },
  actions: {
    async saveRolesStore({ commit }, data) {
      commit('saveRolesStore', await apiRequest.getAll(data));
    },
    async createRole({ commit }, role) {
      commit('createRole', await apiRequest.create(role));
    },
    async updateRole({ commit }, role) {
      commit('updateRole', await apiRequest.update(role));
    },
  },
  getters: {
    getRoles: (state) => state.roles,
  },

};
